import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/page.tsx")